import { render, staticRenderFns } from "./serviceTerms.vue?vue&type=template&id=a2a64776&scoped=true&"
import script from "./serviceTerms.vue?vue&type=script&lang=js&"
export * from "./serviceTerms.vue?vue&type=script&lang=js&"
import style0 from "./serviceTerms.vue?vue&type=style&index=0&id=a2a64776&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2a64776",
  null
  
)

export default component.exports